import React from 'react';
import ReactDOM from 'react-dom';
// import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './core/store/store';
import { start } from 'single-spa';
import { BrowserRouter as Router } from 'react-router-dom';
import ConnectedIntlProvider from './translations/connectedIntlProvider';

import { registerDashboardApp } from './app-registrations/dashboard-app';
import * as serviceWorker from './serviceWorker';
import { ReactIntlErrorCode } from 'react-intl';

//ReactDOM.render(<App />, document.getElementById('root'));

function onError(e: any) {
	if (e.code === ReactIntlErrorCode.MISSING_DATA) {
		return;
	}
	console.error(e)
}

ReactDOM.render(
    <Provider store={store}>
      <ConnectedIntlProvider onError={onError} >
        <Router>
          <App />
        </Router>
      </ConnectedIntlProvider>
    </Provider>,
    document.getElementById('root')
  );

registerDashboardApp();
start();

serviceWorker.unregister();